import Papa from "papaparse";
import { useEffect, useState } from "react";
import { TableVirtuoso } from "react-virtuoso";

const CsvViewer = ({ csvUrl, onLoad }: { csvUrl: string; onLoad: (success: boolean) => void }) => {
	const [data, setData] = useState<any[]>([]);
	const [columns, setColumns] = useState<string[]>([]);

	useEffect(() => {
		if (!csvUrl) return;

		Papa.parse(csvUrl, {
			download: true,
			header: true, // Se il CSV ha intestazioni
			skipEmptyLines: true,
			complete: (result) => {
				setData(result.data as any);
				setColumns(result.meta.fields || []);
				onLoad?.(true);
			},
			error: (error) => {
				console.error("Errore nel parsing del CSV:", error);
				onLoad?.(false);
			},
		});
	}, [csvUrl, onLoad]);

	if (data.length === 0) {
		return (
			<div className="max-w-full mx-auto p-4">
				<h2 className="text-lg font-semibold text-center mb-4 text-secondary">Visualizzatore CSV</h2>
				<p className="text-secondary/60 text-center mt-4 text-lg">Caricamento dati in corso...</p>
			</div>
		);
	}

	return (
		<div className="max-w-full mx-auto p-4">
			<h2 className="text-lg font-semibold text-center mb-4 text-secondary">Visualizzatore CSV</h2>

			<div className="overflow-x-auto border border-secondary/20 rounded-lg shadow-lg">
				<TableVirtuoso
					style={{ height: "calc(100vh - 170px)" }}
					data={data}
					fixedHeaderContent={() => (
						<tr className="bg-[rgb(215_236_241)]">
							{columns.map((col, idx) => (
								<th key={idx} className="px-4 py-3 border-b-2 border-secondary/30 text-left font-bold text-secondary">
									{col}
								</th>
							))}
						</tr>
					)}
					itemContent={(rowIndex, row) => (
						<>
							{columns.map((col, colIndex) => (
								<td key={colIndex} className="px-4 py-2 border-b border-secondary/20">
									{row[col]}
								</td>
							))}
						</>
					)}
				/>
			</div>
		</div>
	);
};

export default CsvViewer;
